var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { BaseSuggestions } from '../../base-suggestions';
import { HighlightWords } from '../../highlight-words';
var PartySuggestions = /** @class */ (function (_super) {
    __extends(PartySuggestions, _super);
    function PartySuggestions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadSuggestionsUrl = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party';
        _this.getLoadSuggestionsData = function () {
            var _a = _this.props, count = _a.count, filterStatus = _a.filterStatus, filterType = _a.filterType, filterOkved = _a.filterOkved, filterLocations = _a.filterLocations, filterLocationsBoost = _a.filterLocationsBoost;
            var query = _this.state.query;
            var requestPayload = {
                query: query,
                count: count || 10,
            };
            // Ограничение по статусу организации
            if (filterStatus) {
                requestPayload.status = filterStatus;
            }
            // Ограничение по ОКВЭД
            // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=1093075333
            if (filterOkved) {
                requestPayload.okved = filterOkved;
            }
            // Ограничение по типу организации
            if (filterType) {
                requestPayload.type = filterType;
            }
            // Сужение области поиска
            if (filterLocations) {
                requestPayload.locations = filterLocations;
            }
            // Приоритет города при ранжировании
            if (filterLocationsBoost) {
                requestPayload.locations_boost = filterLocationsBoost;
            }
            return requestPayload;
        };
        _this.getSuggestionKey = function (suggestion) { return suggestion.data.hid; };
        _this.renderOption = function (suggestion) {
            var _a;
            var _b = _this.props, renderOption = _b.renderOption, highlightClassName = _b.highlightClassName;
            var query = _this.state.query;
            return renderOption ? (renderOption(suggestion, query)) : (React.createElement("div", null,
                React.createElement("div", { className: suggestion.data.state.status === 'LIQUIDATED' ? 'react-dadata__suggestion--line-through' : undefined },
                    React.createElement(HighlightWords, { highlightClassName: highlightClassName || 'react-dadata--highlighted', words: _this.getHighlightWords(), text: suggestion.value })),
                React.createElement("div", { className: "react-dadata__suggestion-subtitle" },
                    suggestion.data.inn && React.createElement("div", { className: "react-dadata__suggestion-subtitle-item" }, suggestion.data.inn),
                    ((_a = suggestion.data.address) === null || _a === void 0 ? void 0 : _a.value) && (React.createElement("div", { className: "react-dadata__suggestion-subtitle-item" },
                        React.createElement(HighlightWords, { highlightClassName: highlightClassName || 'react-dadata--highlighted', words: _this.getHighlightWords(), text: suggestion.data.address.value }))))));
        };
        return _this;
    }
    return PartySuggestions;
}(BaseSuggestions));
export { PartySuggestions };
